/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
});


export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    // apiUrl: 'https://credit-api.virginmoney.co.za/api/v1',
    // apiUrl: 'http://virgin-money-api.local/api/v1',
    // apiUrl: 'https://virgin-money-api.testurl.co/api/v1',
    apiUrl: process.env.VUE_APP_API_URL || 'https://credit-api.dev.virgin-money.wigroup.io/api/v1',
    firstName: '',
    surname: '',
    email: '',
    ID: '',
    cell: '',
    creditReason: '',
    loanAmount: '',
    loanTerm: '',
    typeOfEmployment: '',
    creditConsent: '',
    termConsent: '',
    postalCode: '',
    marriageStatus: '',
    companyName: '',
    startDate: '',
    employementType: '',
    endDate: '',
    occupation: '',
    salary: '',
    salaryTerm: '',
    historicAdvantage: '',
    recaptchaToken: '',
    creditScore: '',
    userId: '',
    callback: '',
    questionData: '',
    questionStatusCode: '',
    transactionId: '',
    referrer: ''
  },
  mutations: {
    // Mutations go here
    firstName (state, n) { state.firstName = n; },
    surname (state, n) { state.surname = n; },
    email (state, n) { state.email = n; },
    ID (state, n) { state.ID = n; },
    cell (state, n) { state.cell = n; },
    creditReason (state, n) { state.creditReason = n; },
    loanAmount (state, n) { state.loanAmount = n; },
    loanTerm (state, n) { state.loanTerm = n; },
    creditConsent (state, n) { state.creditConsent = n; },
    termConsent (state, n) { state.termConsent = n; },
    postalCode (state, n) { state.postalCode = n; },
    marriageStatus (state, n) { state.marriageStatus = n; },
    companyName (state, n) { state.companyName = n; },
    startDate (state, n) { state.startDate = n; },
    employementType (state, n) { state.employementType = n; },
    endDate (state, n) { state.endDate = n; },
    occupation (state, n) { state.occupation = n; },
    salary (state, n) { state.salary = n; },
    salaryTerm (state, n) { state.salaryTerm = n; },
    historicAdvantage (state, n) { state.historicAdvantage = n; },
    recaptchaToken (state, n) { state.recaptchaToken = n; },
    creditScore (state, n) { state.creditScore = n; },
    userId (state, n) { state.userId = n; },
    callback (state, n) { state.callback = n; },
    questionData(state, n) { state.questionData = n; },
    questionStatusCode(state, n) { state.questionStatusCode = n; },
    transactionId(state, n) { state.transactionId = n; },
    referrer(state, n) { state.referrer = n; },

  },
});
